document.addEventListener('DOMContentLoaded', function () {
  var walker = document.createTreeWalker(
    document.body,
    NodeFilter.SHOW_TEXT,
    {
      acceptNode: function (node) {
        if (!node.nodeValue || !node.nodeValue.trim()) {
          return NodeFilter.FILTER_REJECT;
        }

        if (
          node.parentNode.closest('script, style, [data-en-font-ignore]') ||
          node.parentNode.tagName === 'SCRIPT' ||
          node.parentNode.tagName === 'STYLE'
        ) {
          return NodeFilter.FILTER_REJECT;
        }

        // Only text nodes that contain at least one Latin/extended Latin letter
        return /[A-Za-zÀ-ÖØ-öø-ÿ]/.test(node.nodeValue)
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      }
    },
    false
  );

  var textNodes = [];
  var current;
  while ((current = walker.nextNode())) {
    textNodes.push(current);
  }

  textNodes.forEach(function (textNode) {
    var text = textNode.nodeValue;
    var parent = textNode.parentNode;
    var frag = document.createDocumentFragment();

    // Match chunks that:
    //  - contain at least one Latin letter (lookahead)
    //  - may also contain digits, @ and punctuation
    //  - may include spaces inside the chunk (so "Shop Now" stays together)
    //  - but numbers-only sequences are NOT matched
    var regex = /(?=[A-Za-zÀ-ÖØ-öø-ÿ0-9@\-–—'"()\/&.,!? \u00A0]*[A-Za-zÀ-ÖØ-öø-ÿ])[A-Za-zÀ-ÖØ-öø-ÿ0-9@\-–—'"()\/&.,!? \u00A0]+/g;

    var lastIndex = 0;
    var match;

    while ((match = regex.exec(text)) !== null) {
      // Text before the English chunk
      if (match.index > lastIndex) {
        frag.appendChild(
          document.createTextNode(text.slice(lastIndex, match.index))
        );
      }

      // English chunk wrapped in span.en-font
      var span = document.createElement('span');
      span.className = 'en-font';
      span.textContent = match[0];
      frag.appendChild(span);

      lastIndex = match.index + match[0].length;
    }

    // Remainder of the text
    if (lastIndex < text.length) {
      frag.appendChild(document.createTextNode(text.slice(lastIndex)));
    }

    parent.replaceChild(frag, textNode);
  });
});
